module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/queen.e53cc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/queen.jpg
// module id = +WAo
// module chunks = 0